import { Skeleton } from "@mui/material";

export const BankButtonSkeleton = () => (
  <>
    <Skeleton variant="rounded" height={60} />
    <Skeleton variant="rounded" height={60} />
    <Skeleton variant="rounded" height={60} />
    <Skeleton variant="rounded" height={60} />
    <Skeleton variant="rounded" height={60} />
    <Skeleton variant="rounded" height={60} />
  </>
);
